
import { defineComponent } from 'vue'
import IndexForm from '../../components/form/productindex/IndexForm.vue'
import store, { ActionTypes } from '../../store'
import { mapState } from 'vuex'
import {  User } from '../../types'
const loadIndex = function(to:any, from:any, next:any){
  const { id } = to.params
  store.dispatch(ActionTypes.RESET_INDEX).then(() =>
      store.dispatch(ActionTypes.FETCH_PRODUCTS).then(() =>
          store.dispatch(ActionTypes.FETCH_INDEX, id).then(() => next())
      ))
};

export default defineComponent({
  name: 'StrategyUpdate',
  components: {
    IndexForm
  },
  beforeRouteEnter (to, from, next) {
    loadIndex(to, from, next)

  },

  beforeRouteUpdate (to, from, next) {
    loadIndex(to, from, next)
  },
  computed: {
    ...mapState([
      'index','users'
    ])
  },
  created(){
    this.loadUsers(this.users)
  },
  methods:{
    loadUsers(users:Array<User[]>) {
       return store.dispatch( ActionTypes.FETCH_USERS )
    }
  }

})
